module.exports = require("./ko-KP");